import { IconNameEnum, useModuleBEM } from "@b2bportal/core-themes";
import { ButtonTypeEnum } from "@b2bportal/core-ui";
import { useI18nContext } from "@hopper-b2b/i18n";
import { Button, Icon } from "@tenant/ui";
import styles from "./PackageUpSellBanner.module.scss";

interface PackageUpSellBannerProps {
  onStartNewSearch: () => void;
}

export const PackageUpSellBanner = ({
  onStartNewSearch,
}: PackageUpSellBannerProps) => {
  const [block, cn] = useModuleBEM(styles, "PackageUpSellBanner");
  const { t } = useI18nContext();

  return (
    <div className={block}>
      <Icon iconName={IconNameEnum.checkFilled} className={cn("icon")} />
      <div className={cn("content")}>
        <p className={cn("title")}>
          {t("core-packages.hotelAvailability.upSellBanner.title")}
        </p>
        <p className={cn("description")}>
          {t("core-packages.hotelAvailability.upSellBanner.description")}
        </p>
        <Button
          buttonType={ButtonTypeEnum.Link}
          className={cn("cta")}
          onClick={onStartNewSearch}
        >
          {t("core-packages.hotelAvailability.upSellBanner.startNewSearch")}
        </Button>
      </div>
    </div>
  );
};
